import { render } from "./Sidebar.vue?vue&type=template&id=5bfde249"
import script from "./Sidebar.vue?vue&type=script&lang=js"
export * from "./Sidebar.vue?vue&type=script&lang=js"

import "./Sidebar.vue?vue&type=style&index=0&id=5bfde249&lang=css"

import exportComponent from "/home/runner/work/Pacto_console/Pacto_console/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__